// extracted by mini-css-extract-plugin
module.exports = {"submitButtonWrapper":"PickupForm_submitButtonWrapper__2NVJu","pickupLocations":"PickupForm_pickupLocations__lV9X-"};